import { Dispatch, SetStateAction } from "react";
import { downloadFile } from "./TemplateDownload.service";

/**
 * Initiates download of a file and handles blob logic.
 */
export const handleDownload = async (
    endpoint: string,
    params: any,
    filename: string,
    extension: string,
    setExcelDownloading?: Dispatch<SetStateAction<boolean>>,
    isPayloadAFile: boolean = false
  ): Promise<void> => {

    try {
      setExcelDownloading?.(true);
      const blob = await downloadFile(endpoint, params, isPayloadAFile);
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("File download failed", error);
      throw error;
    } finally {
      setExcelDownloading?.(false);
    }
  };
  